import { useState, useEffect } from 'react';
import api from '../utils/api';

export default function useDashboardData() {
  const [analytics, setAnalytics] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [domicilies, setDomicilies] = useState([]);
  const [majors, setMajors] = useState([]);
  const [regencies, setRegencies] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [divisions, setDivisions] = useState([]);

  const [loading, setLoading] = useState({
    usersTotal: true,
    universities: true,
    domicilies: true,
    majors: true,
    regencies: true,
    institutions: true,
    divisions: true,
  });

  useEffect(() => {
    // users totals
    const fetchAnalytics = async () => {
      try {
        const res = await api.analyticsUsersTotal();
        setAnalytics(res || []);
      } catch (err) {
        console.error('analyticsUsersTotal error:', err);
      } finally {
        setLoading((p) => ({ ...p, usersTotal: false }));
      }
    };

    // universities
    const fetchUniversities = async () => {
      try {
        const res = await api.analyticsUsersByUniversities();
        const sorted = (res || []).sort(
          (a, b) => b.total_students - a.total_students
        );
        setUniversities(sorted);
      } catch (err) {
        console.error('analyticsUsersByUniversities error:', err);
      } finally {
        setLoading((p) => ({ ...p, universities: false }));
      }
    };

    // domicilies (by provinces)
    const fetchDomicilies = async () => {
      try {
        const res = await api.analyticsUsersByProvincies();
        const sorted = (res || []).sort(
          (a, b) => b.total_users - a.total_users
        );
        setDomicilies(sorted);
      } catch (err) {
        console.error('analyticsUsersByProvincies error:', err);
      } finally {
        setLoading((p) => ({ ...p, domicilies: false }));
      }
    };

    // majors
    const fetchMajors = async () => {
      try {
        const res = await api.analyticsUsersByMajor();
        const sorted = (res || []).sort(
          (a, b) => b.total_users - a.total_users
        );
        setMajors(sorted);
      } catch (err) {
        console.error('analyticsUsersByMajor error:', err);
      } finally {
        setLoading((p) => ({ ...p, majors: false }));
      }
    };

    // regencies
    const fetchRegencies = async () => {
      try {
        const res = await api.analyticsUsersByRegencies();
        const sorted = (res || []).sort(
          (a, b) => b.total_users - a.total_users
        );
        setRegencies(sorted);
      } catch (err) {
        console.error('analyticsUsersByRegencies error:', err);
      } finally {
        setLoading((p) => ({ ...p, regencies: false }));
      }
    };

    // institutions
    const fetchInstitutions = async () => {
      try {
        const res = await api.analyticsUsersByInstitutions();
        const sorted = (res || []).sort(
          (a, b) => (b.total_users ?? 0) - (a.total_users ?? 0)
        );
        setInstitutions(sorted);
      } catch (err) {
        console.error('analyticsUsersByInstitutions error:', err);
      } finally {
        setLoading((p) => ({ ...p, institutions: false }));
      }
    };

    // divisions
    const fetchDivisions = async () => {
      try {
        const res = await api.analyticsUsersByDivision();
        const sorted = (res || []).sort(
          (a, b) => (b.total_users ?? 0) - (a.total_users ?? 0)
        );
        setDivisions(sorted);
      } catch (err) {
        console.error('analyticsUsersByDivision error:', err);
      } finally {
        setLoading((p) => ({ ...p, divisions: false }));
      }
    };

    fetchAnalytics();
    fetchUniversities();
    fetchDomicilies();
    fetchMajors();
    fetchRegencies();
    fetchInstitutions();
    fetchDivisions();
  }, []);

  return {
    analytics,
    universities,
    domicilies,
    majors,
    regencies,
    institutions,
    divisions,
    loading,
  };
}
